"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BehaviorSubject_1 = require("rxjs/BehaviorSubject");
var AppService = /** @class */ (function () {
    function AppService() {
        this.isStandAloneApp = false;
        this.displaySize = new BehaviorSubject_1.BehaviorSubject('lg');
    }
    AppService.prototype.setDisplaySize = function (width) {
        var size = 'sm';
        if (width > 1007) {
            size = 'lg';
        }
        else if (width > 640) {
            size = 'md';
        }
        console.log("new size " + size);
        this.displaySize.next(size);
    };
    return AppService;
}());
var service = new AppService();
exports.default = service;
//# sourceMappingURL=app-service.js.map


// WEBPACK FOOTER //
// ./src/core/services/app-service.js